import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 24px;
  padding-right: 24px;
`;

export const FormContainer = styled.div`
  margin: 2rem 0rem;

  form {
    .react-select__control {
      overflow: unset;

      .react-select__value-container {
        height: 36px !important;
      }

      .css-1uccc91-singleValue {
        display: flex !important;
        align-items: center !important;
      }
    }

    .react-select__menu {
      .react-select__menu-list {
        display: flex;
        flex-direction: column;

        .react-select__option {
          display: flex;
          align-items: center;
        }
      }
    }
  }
`;

export const FormFooter = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
